module.exports = __webpack_public_path__ + "nr.svg?635d72d4c86d814c6f513ff316df9d41";